import { render, staticRenderFns } from "./paymember_fail.vue?vue&type=template&id=656c4898&"
import script from "./paymember_fail.vue?vue&type=script&lang=js&"
export * from "./paymember_fail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports